module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(!_vm.show) ? _c('el-button', {
    staticClass: "margin-b-10 small",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.show = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.add').toUpperCase()) + " " + _vm._s(_vm.$t(("form.addressTypes.options." + (_vm.camelize(_vm.name))))) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('el-collapse-transition', [(_vm.show) ? _c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.clients",
      "hasLabel": true
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.show && _vm.form.streetName && _vm.name !== 'Postal') ? _c('el-button', {
    staticClass: "margin-b-10 small dark",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.destroy($event)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.delete').toUpperCase()) + "\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bfceec2","hasScoped":false}!./src/app/components/clientAddress/clientAddress.html
// module id = 3024
// module chunks = 1